/* FREIE WÄHLER NRW Theme — UI + Shopify AJAX-Warenkorb */
(function(){
  'use strict';
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  function money(cents){ try{ return (cents/100).toLocaleString('de-DE',{style:'currency',currency:window.__shopCurrency||'EUR'}); }catch(e){ return (cents/100).toFixed(2)+' €'; } }

  // Toast
  var toast,tt;
  window.fwToast=function(m){ if(!toast){toast=document.createElement('div');toast.className='fw-toast';document.body.appendChild(toast);} toast.textContent=m;toast.classList.add('is-on');clearTimeout(tt);tt=setTimeout(function(){toast.classList.remove('is-on');},2400); };
  window.fwCartPop=function(){ var p=document.querySelector('[data-cart-pop]'); if(p){p.classList.remove('pop');void p.offsetWidth;p.classList.add('pop');} };

  function setCount(n){ document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent=n; el.classList.toggle('is-empty', n===0); }); }
  function refreshCount(){ fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){ setCount(c.item_count); }).catch(function(){}); }

  ready(function(){
    // generic swatch groups
    document.addEventListener('click',function(e){
      var sw=e.target.closest('.js-swatch'); if(!sw) return; var g=sw.closest('[data-swatch-group]'); if(!g) return;
      g.querySelectorAll('.js-swatch').forEach(function(s){s.classList.remove('is-active');s.setAttribute('aria-pressed','false');});
      sw.classList.add('is-active');sw.setAttribute('aria-pressed','true');
    });
    // drawers (menu + filters)
    document.addEventListener('click',function(e){
      var t=e.target.closest('.js-menu-toggle');
      if(t){ var sel=t.getAttribute('data-target')||'.fw-drawer'; var tg=document.querySelector(sel); if(tg) tg.classList.toggle('is-open'); document.body.classList.toggle('no-scroll'); }
      if(e.target.classList.contains('fw-drawer__scrim')||e.target.closest('.js-menu-close')){ document.querySelectorAll('.fw-drawer.is-open,.filters.is-open').forEach(function(d){d.classList.remove('is-open');}); document.body.classList.remove('no-scroll'); }
    });
    // reveal
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');io.unobserve(x.target);}});},{threshold:.12,rootMargin:'0px 0px -40px 0px'});
    document.querySelectorAll('.reveal').forEach(function(el){io.observe(el);});
    // sticky
    var hdr=document.querySelector('[data-sticky]');
    if(hdr){ var on=function(){hdr.classList.toggle('is-stuck',window.scrollY>8);}; window.addEventListener('scroll',on,{passive:true}); on(); }
    // accordion (generic: FAQ, Produktdetails)
    document.addEventListener('click',function(e){
      var b=e.target.closest('.acc__btn'); if(!b) return; var item=b.closest('.acc__item'); var p=item.querySelector('.acc__panel'); if(!p) return;
      var open=item.classList.toggle('is-open'); p.style.maxHeight=open?p.scrollHeight+'px':'0';
    });

    // ---- Quick add (collection/featured cards) ----
    document.addEventListener('submit',function(e){
      var form=e.target.closest('form[data-quick-add]'); if(!form) return; e.preventDefault();
      var fd=new FormData(form);
      fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:fd}).then(function(r){return r.json();}).then(function(){
        window.fwCartPop(); refreshCount(); window.fwToast(form.getAttribute('data-name')+' in den Warenkorb gelegt');
      }).catch(function(){ window.fwToast('Konnte nicht hinzugefügt werden'); });
    });

    refreshCount();
  });
})();